module.exports = __webpack_public_path__ + "static/media/Expo 2020 Dubai_.72ac0e61.jpg";